import { IExpert } from '@/shared/IExpert';
import { ExpertDialog } from './ExpertDialog';

export const EditExpertDialog = (props: {
  onClose: () => void;
  expert: IExpert;
  setExpert: (expert: IExpert) => void;
  onSave: (expert: IExpert, invite: boolean) => Promise<void>;
}) => {

  const onSaveExpert = async (expert: IExpert, invite: boolean) => {
    await props.onSave(expert, invite);
    props.setExpert(expert);
  };

  return (
    <ExpertDialog
      onClose={props.onClose}
      expert={props.expert}
      onSave={onSaveExpert}
      title='Update Expert'
      description='This will modify the existing course expert.'
      saveLabel='Save'
      savingLabel='Saving...'
    />
  )
}